var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduction"},[_c('sys-bar',{ref:"sysBar",attrs:{"backable":true}}),_c('div',{ref:"content",staticClass:"content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }